import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../service/getNumberOfLayers"
import { isMetal, isRigid } from "../../../../service/oneClickIs"
import type EstimateValues from "../../../../types/params"

const replaceDataService = (values: EstimateValues) => {
  const isDisplayed = getDisplayCondition(values)

  if (isDisplayed.dataService) {
    const getId = () => {
      const numberOfLayers = getNumberOfLayers(values)
      if (isRigid(values) && numberOfLayers === 1) return "リジッド1層"
      if (isRigid(values) && numberOfLayers === 2) return "リジッド2層"
      if (isRigid(values) && numberOfLayers === 4) return "リジッド4層"
      if (isRigid(values) && numberOfLayers === 6) return "リジッド6層"
      if (isRigid(values) && numberOfLayers === 8) return "リジッド8層"
      if (isRigid(values) && numberOfLayers === 10) return "リジッド10層"
      if (isRigid(values) && numberOfLayers === 12) return "リジッド12層"
      if (isMetal(values) && numberOfLayers === 1) return "メタル1層"
      if (isMetal(values) && numberOfLayers === 2) return "メタル2層"
    }

    const layerId = getId()
    if (!layerId) return ESTIMATE_CONSTANT.データ面付け編集サービス.なし.value

    const names = ["同種面付", "2種面付", "3種面付", "4種面付", "5種面付", "6種面付", "7種面付", "8種面付"] as const
    for (const name of names) {
      switch (values.dataService) {
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(リジッド1層)`].value:
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(リジッド2層)`].value:
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(リジッド4層)`].value:
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(リジッド6層)`].value:
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(リジッド8層)`].value:
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(リジッド10層)`].value:
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(リジッド12層)`].value:
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(メタル1層)`].value:
        case ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(メタル2層)`].value:
          return ESTIMATE_CONSTANT.データ面付け編集サービス[`${name}(${layerId})`].value
      }
    }
  }

  return values.dataService
}

export default replaceDataService
